// state.js — the minimal global app container. Holds ONLY cross-cutting state
// (auth user, current route, page cleanup). Everything else is component-local
// signals — this is deliberately small so there's no god-object (the old app.js
// `state` grab-bag is what made page teardown ad-hoc and drift-prone).

import { signal } from './signal.js';

export const state = {
  user: signal(null),        // { id, email, name, picture_url, plan, role } | null
  route: signal(null),       // { name, params, path, query } | null
  booted: signal(false),     // auth bootstrap finished
};

export const isAuthed = () => !!state.user.peek();
export const isPro = () => {
  const u = state.user.peek();
  if (!u) return false;
  if (u.plan === 'lifetime') return true;
  if (u.plan === 'pro') return !u.trial_expires_at || new Date(u.trial_expires_at) > new Date();
  return false;
};

// Page-cleanup registry: the router runs the previous page's cleanup before the
// next mounts. Components mostly self-clean via the base class; this covers
// imperative page-level resources (intervals, global listeners, media).
let pageCleanup = null;
export function setPageCleanup(fn) { pageCleanup = fn; }
export function runPageCleanup() {
  if (!pageCleanup) return;
  try { pageCleanup(); } catch (err) { console.error('[state] pageCleanup threw:', err); }
  pageCleanup = null;
}
